// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__UvkBa","col":"styles_col__306SU"};